const makeConstant = constant => `playbook/${constant}`

export const CREATE_NEWSLETTER_PLAYBOOK = makeConstant('CREATE_NEWSLETTER_PLAYBOOK')
export const CREATE_NEWSLETTER_PLAYBOOK_SUCCESS = makeConstant('CREATE_NEWSLETTER_PLAYBOOK_SUCCESS')
export const CREATE_NEWSLETTER_PLAYBOOK_PENDING = makeConstant('CREATE_NEWSLETTER_PLAYBOOK_PENDING')
export const CREATE_NEWSLETTER_PLAYBOOK_FAILED = makeConstant('CREATE_NEWSLETTER_PLAYBOOK_FAILED')

export const CREATE_DEMO_REQUEST_PLAYBOOK = makeConstant('CREATE_DEMO_REQUEST_PLAYBOOK')
export const CREATE_DEMO_REQUEST_PLAYBOOK_SUCCESS = makeConstant('CREATE_DEMO_REQUEST_PLAYBOOK_SUCCESS')
export const CREATE_DEMO_REQUEST_PLAYBOOK_PENDING = makeConstant('CREATE_DEMO_REQUEST_PLAYBOOK_PENDING')
export const CREATE_DEMO_REQUEST_PLAYBOOK_FAILED = makeConstant('CREATE_DEMO_REQUEST_PLAYBOOK_FAILED')

export const UPDATE_CLP_SETTINGS = makeConstant('UPDATE_CLP_SETTINGS')
export const UPDATE_CLP_SETTINGS_SUCCESS = makeConstant('UPDATE_CLP_SETTINGS_SUCCESS')
export const UPDATE_CLP_SETTINGS_PENDING = makeConstant('UPDATE_CLP_SETTINGS_PENDING')
export const UPDATE_CLP_SETTINGS_FAILED = makeConstant('UPDATE_CLP_SETTINGS_FAILED')

export const FETCH_CLP_SETTINGS = makeConstant('FETCH_CLP_SETTINGS')
export const FETCH_CLP_SETTINGS_SUCCESS = makeConstant('FETCH_CLP_SETTINGS_SUCCESS')
export const FETCH_CLP_SETTINGS_PENDING = makeConstant('FETCH_CLP_SETTINGS_PENDING')
export const FETCH_CLP_SETTINGS_FAILED = makeConstant('FETCH_CLP_SETTINGS_FAILED')

export const FETCH_CLP_SUBDOMAIN = makeConstant('FETCH_CLP_SUBDOMAIN')
export const FETCH_CLP_SUBDOMAIN_SUCCESS = makeConstant('FETCH_CLP_SUBDOMAIN_SUCCESS')
export const FETCH_CLP_SUBDOMAIN_PENDING = makeConstant('FETCH_CLP_SUBDOMAIN_PENDING')
export const FETCH_CLP_SUBDOMAIN_FAILED = makeConstant('FETCH_CLP_SUBDOMAIN_FAILED')

export const SET_CLP_SUBDOMAIN = makeConstant('SET_CLP_SUBDOMAIN')

export const FETCH_CLP_CNAME = makeConstant('FETCH_CLP_CNAME')
export const FETCH_CLP_CNAME_SUCCESS = makeConstant('FETCH_CLP_CNAME_SUCCESS')
export const FETCH_CLP_CNAME_PENDING = makeConstant('FETCH_CLP_CNAME_PENDING')
export const FETCH_CLP_CNAME_FAILED = makeConstant('FETCH_CLP_CNAME_FAILED')

export const SET_PLAYBOOK_TYPE = makeConstant('SET_PLAYBOOK_TYPE')

export const CREATE_WELCOME_PLAYBOOKS = makeConstant('CREATE_WELCOME_PLAYBOOKS')
export const CREATE_WELCOME_PLAYBOOKS_SUCCESS = makeConstant('CREATE_WELCOME_PLAYBOOKS_SUCCESS')
export const CREATE_WELCOME_PLAYBOOKS_PENDING = makeConstant('CREATE_WELCOME_PLAYBOOKS_PENDING')
export const CREATE_WELCOME_PLAYBOOKS_FAILED = makeConstant('CREATE_WELCOME_PLAYBOOKS_FAILED')

// Demo Request Playbook Props
export const SET_PRODUCT_NAME = makeConstant('SET_PRODUCT_NAME')
export const SET_VALUE_PROP = makeConstant('SET_VALUE_PROP')
export const SET_INDUSTRY = makeConstant('SET_INDUSTRY')

export const SET_WIDGET_VERIFIED = makeConstant('SET_WIDGET_VERIFIED')


// WEBPACK FOOTER //
// ./src/modules/playbook/constants.js